module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/acupuncture-treats.json
// module id = 365
// module chunks = 44777266195455